
const GATrackingCode = 'UA-4831889-30';
let GACreated = null;

/**
 * Send event to Google analytics
 * @param {string} eventCategory event category
 * @param {string} eventAction event action
 * @param {string} eventLabel event label
  * @param {number} eventValue event value
*/
function sendGAEvent(eventCategory, eventAction, eventLabel, eventValue) {
  if( typeof window.ga !== 'undefined' && window.ga ){

    if( !GACreated ){
      window.ga('create', GATrackingCode, 'auto');
      GACreated = true;
    }

    window.ga('send', {
      hitType: 'event',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue
    });
  }
}

/*
Push event details to Datalayer, to be passed to Google services (Tag Manager)
*/
function pushEventToDatalayer(event) {
  if(typeof window.dataLayer !== 'undefined'){
    window.dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': event.eventCategory,
      'eventAction': event.eventAction,
      'eventLabel': event.eventLabel
    });
  }
}

/*
Push object to Datalayer, to be passed to Google services (Tag Manager)
*/
function pushObjectToDatalayer(object) {
  if(typeof window.dataLayer !== 'undefined'){
    window.dataLayer.push(object);
  }
}

module.exports = {
  pushEventToDatalayer, pushObjectToDatalayer, sendGAEvent
};
